export default __webpack_public_path__ + "../staticImages/A0001000.svg";